import Email from "@/domain/entities/emails/Email";
import { getLinksFromMailsList, getTodosFromMailsList } from "@/lib/utils";
import { Link as LinkIcon, ListTodoIcon, Paperclip } from "lucide-react";

type MailIconsProps = {
    mail: Email;
};

const MailIcons = ({ mail }: MailIconsProps) => (
    <div className="flex shrink-0 gap-1.5 text-text-caption" id="icons">
        {getTodosFromMailsList([mail]).length > 0 && (
            <ListTodoIcon className="h-4 w-4 shrink-0 [@container_mailrow_(max-width:460px)]:hidden" />
        )}
        {getLinksFromMailsList([mail]).length > 0 && (
            <LinkIcon className="h-4 w-4 shrink-0 [@container_mailrow_(max-width:420px)]:hidden" />
        )}
        {mail.hasAttachment && (
            <Paperclip className="h-4 w-4 shrink-0 [@container_mailrow_(max-width:380px)]:hidden" />
        )}
    </div>
);

export default MailIcons;
